// extracted by mini-css-extract-plugin
export default {"ag-styles":"bf_g","toolbar":"bf_N5","controlsContainer":"bf_N6","controls":"bf_n","scrollIndicator":"bf_N7","videoTour":"bf_N8"};